<template>
    <form
        class="form-password-reset"
        :class="{'form-password-reset--preloader': show.preloader}">
        <h2 class="form-password-reset__heading">Yeni şifreni belirle</h2>
        <p class="form-password-reset__description">Aşağıdaki formdan yeni şifreni belirleyebilirsin.</p>
        <span class="form-password-reset__art-separator"></span>

        <Preloader
            v-if="show.preloader"
            preloaderText="Yükleniyor..." />

        <div
            v-if="!show.preloader && !show.successNotification"
            class="input-group"
            :class="{'input-group--error': css.errPassNew}">
            <div class="wr-label">
                <label class="input-group__label" for="passNew">Yeni Şifre</label>
                <p class="input-group__err-message">{{ errMessage.pass }}</p>
            </div>

            <div
                v-if="!show.inpPassRevealed"
                class="wr-input">
                <input
                    class="input-group__inp-pass" id="passNew" type="password"
                    :value="$store.state.input.resetPassword.passNew"
                    @input="inputPassNew">
                <button
                    class="btn-show-password" type="button"
                    @click="showPassword">
                    <svg class="btn-show-password__icon" width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_896)"><path d="M1.69.705a.75.75 0 00-1.38.59l1.38-.59zM8.04 7.738a.75.75 0 10-1.257-.818l1.257.818zM5.371 9.09a.75.75 0 101.258.818L5.37 9.091zM21.69 1.295a.75.75 0 00-1.378-.59l1.378.59zM18.97 7.16A.75.75 0 1020.03 6.1l-1.06 1.06zM10.25 10.5a.75.75 0 001.5 0h-1.5zm5.121-.591a.75.75 0 101.257-.818l-1.257.818zm-10.84-4.25A.75.75 0 003.47 4.6l1.06 1.06zM1.97 6.1a.75.75 0 001.06 1.06L1.97 6.1zM11 7.25c-3.224 0-5.539-1.605-7.075-3.26a13.637 13.637 0 01-1.702-2.28 11.706 11.706 0 01-.507-.946 3.903 3.903 0 01-.027-.06L1 1l-.688.295v.002l.001.002.003.006a3.837 3.837 0 00.04.088 13.202 13.202 0 00.58 1.084c.41.69 1.034 1.61 1.89 2.533C4.54 6.855 7.224 8.75 11 8.75v-1.5zm3.313-.62c-.97.383-2.071.62-3.313.62v1.5c1.438 0 2.725-.276 3.862-.723l-.55-1.396zm-7.529.29L5.371 9.09l1.258.818L8.04 7.738 6.784 6.92zM21 1l-.69-.295.001-.001v.002l-.007.013a8.073 8.073 0 01-.152.313 13.298 13.298 0 01-2.666 3.55l1.027 1.094a14.802 14.802 0 003.122-4.26l.039-.085.01-.024.003-.007.002-.003v-.002L21 1zm-3.513 3.582c-.86.806-1.913 1.552-3.174 2.049l.549 1.396c1.473-.58 2.685-1.444 3.651-2.351l-1.026-1.094zm-.017 1.077l1.5 1.5 1.06-1.06-1.5-1.5-1.06 1.06zM10.25 8v2.5h1.5V8h-1.5zm3.709-.262l1.412 2.171 1.257-.818-1.412-2.171-1.257.818zm-10.49-3.14l-1.5 1.5L3.03 7.16l1.5-1.5L3.47 4.6z" fill="#AAA"/></g><defs><clipPath id="clip0_1_896"><path fill="#fff" d="M0 0h22v12H0z"/></clipPath></defs></svg>
                </button>
                <svg class="input-group__inp-pass-icon" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_823)"><path class="input-group__inp-pass-icon-path" d="M7.2 10v1.6m-4-5.177c.378-.023.843-.023 1.44-.023h5.12c.599 0 1.064 0 1.44.023m-8 0c-.47.029-.804.093-1.089.239A2.4 2.4 0 001.062 7.71c-.261.514-.261 1.186-.261 2.53v1.12c0 1.344 0 2.016.261 2.53a2.4 2.4 0 001.05 1.048c.513.262 1.185.262 2.529.262h5.12c1.344 0 2.016 0 2.53-.262a2.4 2.4 0 001.048-1.048c.262-.514.262-1.186.262-2.53v-1.12c0-1.344 0-2.016-.262-2.53a2.4 2.4 0 00-1.049-1.048c-.285-.146-.619-.21-1.09-.239m-8 0V4.8a4 4 0 018 0v1.623" stroke="#AAA" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_823"><path fill="#fff" d="M0 0h14.4v16H0z"/></clipPath></defs></svg>
            </div>

            <div
                v-if="show.inpPassRevealed"
                class="wr-input">
                <input
                    class="input-group__inp-pass" id="passNew" type="text"
                    :value="$store.state.input.resetPassword.passNew"
                    @input="inputPassNew">
                <button
                    class="btn-hide-password" type="button"
                    @click="hidePassword">
                    <svg class="btn-hide-password__icon" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_739)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.8l2.464-2.956a5.124 5.124 0 017.872 0L12.8 4.8l-2.464 2.956a5.124 5.124 0 01-7.872 0L0 4.8zm6.4 2.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z" fill="#000"/></g><defs><clipPath id="clip0_1_739"><path fill="#fff" d="M0 0h12.8v9.6H0z"/></clipPath></defs></svg>
                </button>
                <svg class="input-group__inp-pass-icon" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_823)"><path class="input-group__inp-pass-icon-path" d="M7.2 10v1.6m-4-5.177c.378-.023.843-.023 1.44-.023h5.12c.599 0 1.064 0 1.44.023m-8 0c-.47.029-.804.093-1.089.239A2.4 2.4 0 001.062 7.71c-.261.514-.261 1.186-.261 2.53v1.12c0 1.344 0 2.016.261 2.53a2.4 2.4 0 001.05 1.048c.513.262 1.185.262 2.529.262h5.12c1.344 0 2.016 0 2.53-.262a2.4 2.4 0 001.048-1.048c.262-.514.262-1.186.262-2.53v-1.12c0-1.344 0-2.016-.262-2.53a2.4 2.4 0 00-1.049-1.048c-.285-.146-.619-.21-1.09-.239m-8 0V4.8a4 4 0 018 0v1.623" stroke="#AAA" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_823"><path fill="#fff" d="M0 0h14.4v16H0z"/></clipPath></defs></svg>
            </div>
        </div>

        <div
            v-if="!show.preloader && !show.successNotification"
            class="wr-buttons">
            <button
                class="btn-confirm" type="button"
                @click="$store.state.envDev ? submitPasswordResetForm() : submitPasswordResetFormApi()">Onayla</button>
        </div>

        <div
            v-if="show.successNotification"
            class="success-notification">
            <span class="success-notification__art-success"></span>
            <h2 class="success-notification__heading">Başarılı</h2>
            <p class="success-notification__text">Şifren başarıyla değiştirildi.</p>
        </div>
    </form>
</template>
<script>
    import Preloader from '@/components/Preloader.vue';

    export default {
        components: {
            Preloader,
        },

        data(){
            return {
                show: {
                    preloader: false,
                    inpPassRevealed: false,
                    successNotification: false,
                },
                css: {
                    errPassNew: false,
                },
                errMessage: {
                    pass: ''
                }
            };
        },

        methods: {
            showPassword(){
                this.show.inpPassRevealed = true;
            },

            hidePassword(){
                this.show.inpPassRevealed = false;
            },

            inputPassNew(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'resetPassword',
                    dataLabel: 'passNew',
                    data: event.currentTarget.value,
                });
            },

            validatePasswordResetForm(){
                // Reset all error classes and messages from previous attempts.
                this.css.errPassNew = false;
                this.errMessage.pass = '';

                // Validate password.
                let minLength = this.$store.state.validation.minLength.resetPassword.pass;
                if(this.$store.state.input.resetPassword.passNew.length < minLength){
                    this.$foneturkError({
                        text: `Yeni şifren en az ${minLength} karakter olmalı.`
                    });
                    this.errMessage.pass = `En az ${minLength} karakter.`;
                    this.css.errPassNew = true;
                    return false;
                }
                return true;
            },

            submitPasswordResetForm(){
                // Validate form.
                if(!this.validatePasswordResetForm()){
                    return;
                }

                // Show preloader.
                this.show.preloader = true;

                // Send request.
                fetch(this.$store.state.jsonServer.confirmPasswordReset)
                .then(response => {
                    this.show.preloader = false;
                    return response.json();
                })
                .then(confirmationData => {

                });
            },

            submitPasswordResetFormApi(){
                // Validate form.
                if(!this.validatePasswordResetForm()){
                    return;
                }

                // Show preloader.
                this.show.preloader = true;
                
                // Prepare request payload.
                let passwordResetConfirmationOptions = {
                    email: this.$route.query.email,
                    passwordNew: this.$store.state.input.resetPassword.passNew,
                    confirmationCode: this.$route.query.code,
                };

                fetch(this.$store.state.api.confirmPasswordReset, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    credentials: 'include',
                    body: 'passwordResetConfirmationOptions=' + JSON.stringify(passwordResetConfirmationOptions),
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    this.show.successNotification = true;
                })
                .catch(err => {
                    console.error(err);
                    if(err.code == 'CONFIRM_PASSWORD_RESET_MODEL/RUN::PASSWORD_RESET_REQUEST_EXPIRED'){
                        this.$foneturkError({
                            text: 'Şifre sıfırlama isteğinin süresi doldu, yeni bir istek yap.'
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti'
                        });
                    }
                })
            }
        },

        mounted(){
            console.log(this.$route);
        }
    };
</script>
<style scoped src="@/css/components/form-password-reset.css"></style>